var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "avue-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "formUnit",
          attrs: {
            option: _vm.optionUnit,
            "upload-after": _vm.uploadAfter,
            "upload-before": _vm.onUploadBefore,
          },
          on: { submit: _vm.submitUnit },
          model: {
            value: _vm.formUnit,
            callback: function ($$v) {
              _vm.formUnit = $$v
            },
            expression: "formUnit",
          },
        },
        [
          _c(
            "template",
            { slot: "name" },
            [
              _c("el-autocomplete", {
                ref: "unitName",
                staticStyle: { width: "100%" },
                attrs: {
                  debounce: 0,
                  disabled: _vm.isAbleUnitName,
                  "fetch-suggestions": _vm.querySearch,
                  "trigger-on-focus": true,
                  clearable: "",
                  placeholder: "请填写 企业名称",
                },
                on: { clear: _vm.onUnitNameClear, select: _vm.unitChanged },
                model: {
                  value: _vm.formUnit.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.formUnit, "name", $$v)
                  },
                  expression: "formUnit.name",
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "menuForm" },
            [
              _vm.isSubmitted
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-edit" },
                      on: { click: _vm.modifyUnit },
                    },
                    [_vm._v("修改")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c("geti-business-dialog", {
        ref: "geti_dialog",
        on: { onGetiSure: _vm.onGetiSure },
      }),
      _c("jianzhu-hint-dialog", {
        ref: "jianzhu_dialog",
        on: { onJianzhuHint: _vm.onJianzhuHint },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }